/*global FakeCation*/
(function (FC) {
  "use strict";

  FC.utils.registerFilter('transform', function (imgData, cb, config) {
    var rotate = config.rotate,
      scale = config.scale,
      translate = config.translate,
      tmpCanvas = document.createElement('canvas'),
      tmpCanvasCtx = tmpCanvas.getContext('2d'),
      tmp2Canvas = document.createElement('canvas'),
      tmp2CanvasCtx = tmp2Canvas.getContext('2d');

    tmpCanvas.width = tmp2Canvas.width = imgData.width;
    tmpCanvas.height = tmp2Canvas.height = imgData.height;
    
    tmp2CanvasCtx.putImageData(imgData, 0, 0);
    
    tmpCanvasCtx.drawImage(tmp2Canvas, translate.x, (tmpCanvas.height - tmp2Canvas.height * scale.y)+translate.y, tmp2Canvas.width * scale.x, tmp2Canvas.height * scale.y);

    cb(tmpCanvasCtx.getImageData(0, 0, tmpCanvas.width, tmpCanvas.height));
  });
}(FakeCation));
